import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.scss'],
  standalone: false,
})
export class PopupComponent {
  @Input() title: string = 'defaultModal.title';
  @Input() description: string = 'defaultModal.description';
  @Input() successButton: string = 'common.confirmButton';
  @Input() cancelButton: string = 'common.cancelButton';

  constructor(public _activeModal: NgbActiveModal) {}

  buttonClicked(status: boolean) {
    this._activeModal.close(status);
  }
}
